import React from 'react';
import { toast, ToastOptions, ToastContainer, ToastContentProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorToast, SuccessToast } from '@hz-design-system/web-ui';
import 'react-toastify/dist/ReactToastify.css';
import Classes from './ToastNotification.scss';

export type TToastNotificationProps = {
  type: 'success' | 'error';
  description: string | JSX.Element;
};

const ToastNotification = ({ type = 'success', description = '' }: TToastNotificationProps) => {
  const options: ToastOptions = {
    autoClose: 30000,
    closeButton: false,
    hideProgressBar: true,
    position: 'bottom-center',
    pauseOnHover: true,
    className: Classes.message,
    progressClassName: Classes.progressBar,
    bodyClassName: Classes.body,
    draggable: false,
  };

  if (type === 'success') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <SuccessToast icon="checkmark-circle" onClose={closeToast}>
          {description}
        </SuccessToast>
      ),
      options,
    );
  }

  if (type === 'error') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <ErrorToast icon="alert" onClose={closeToast}>
          {description}
        </ErrorToast>
      ),
      options,
    );
  }

  return <ToastContainer />;
};

export default ToastNotification;

export const dismissToast = toast.dismiss;
